import { SELECT_OPTION } from '../constants';

export const initialState = {};

export default (state = initialState, { type, payload = {} }) =>
  type === SELECT_OPTION ? { ...state, [payload.key]: payload.value } : state;
